/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Package_Count_InvalidInputs */

const vi_carrier_form_package_count_invalid = /** @type {(inputs: Carrier_Form_Package_Count_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số kiện phải là số nguyên từ 1 trở lên.`)
};

/**

* @param {Carrier_Form_Package_Count_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_package_count_invalid = /** @type {((inputs?: Carrier_Form_Package_Count_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Package_Count_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_package_count_invalid(inputs)
});